module.exports = __webpack_public_path__ + "img/vuma-logo-pink.946d949b.svg";